import api from './config/api';
import axios from './config/axios';

export default {
    /**
     * getOutboundItems
     * @GET
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @returns { AxiosPromise }
     */
    getOutboundItems( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/delivery/getOutboundItems` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * @GET
     * Get a list of in-transit deliveries
     * @param jwtToken
     * @param website
     * @param userAccountId
     * response.data.mailSearchListDTO looks like:
     * [ {
     *     id: { Number },
     *     refNum: { Number },
     *     mailTypeFriendly: { String },
     *     mailTypeId: { Number },
     *     customerFullName: { String },
     *     customerFirstName: { String },
     *     customerLastName: { String },
     *     customerId: { Number },
     *     customerExternalRefNum: { String },
     *     mailCarrierFriendly: { String },
     *     mailCarrierId: { Number },
     *     sender: { String },
     *     dateReceived: { String },
     *     dateDelivered: { String },
     *     trackingNumber: { String },
     *     locatorDescription: { String },
     *     locatorId: { Number },
     *     destinationLocatorDescription: { String },
     *     destinationLocatorId: { Number },
     *     sku: { String },
     *     active: { Boolean },
     *     damaged: { Boolean },
     * } ]
     */
    getInTransitDeliveries( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/delivery/getInTransitItems` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * Generate a delivery picklist by item ids
     * @POST
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param idList { Array } of mailItem id's
     */
    generatePicklist( {
        jwtToken,
        websiteId,
        userAccountId,
        idList,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/delivery/picklist` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                identifierList: idList,
            },
        } );
    },

    /**
     * @GET
     * Get a list of in-progress deliveries
     * @param jwtToken
     * @param website
     * @param userAccountId
     */
    getInProgressDeliveries( {
        jwtToken,
        websiteId,
        userAccountId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/delivery/picklist/inProgress` ),
            method: 'get',
            headers: api.authHeaders( jwtToken ),
        } );
    },

    /**
     * Deliver mail items to a locator
     * @POST
     * @param jwtToken
     * @param website
     * @param userAccountId
     * @param { Number[] } mailItemIdList - of mailItem id's
     * @param { String } notes
     * @param { Array } photos - of [{ checkSum: '', data: '' }]
     * @param { Number } locatorId
     */
    deliverMailItem( {
        jwtToken,
        websiteId,
        userAccountId,
        mailItemIdList,
        notes,
        photos,
        locatorId,
    } ) {
        return axios( {
            url: api.logisticsUrl( `${ websiteId }/${ userAccountId }/mail/delivery/trans` ),
            method: 'post',
            headers: api.authHeaders( jwtToken ),
            data: {
                mailItems: mailItemIdList,
                notes,
                photos,
                locatorId,
            },
        } );
    },
};
